import React from 'react';
import propTypes from 'prop-types';

import { SuiContainer } from '@splashthat/sui';

import withAppearTransition from 'common/hoc/withAppearTransition';

const SuiContainerWithAppearTransition = withAppearTransition(SuiContainer);

/**
 * Implementation of visual layout of questions.
 * This component should not contain behavior implementation.
 */
const QuestionView = (props) => (
    <SuiContainerWithAppearTransition data-qa="QuestionView" variation="flex-group" in={props.visible} appear>
        {props.children}
    </SuiContainerWithAppearTransition>
);

QuestionView.propTypes = {
    children: propTypes.oneOfType([propTypes.element, propTypes.array]).isRequired,
    visible: propTypes.bool.isRequired,
};

export default QuestionView;
